export default __webpack_public_path__ + "static/media/bigArrow.adff4d88.svg";